// Copyright (c) StrangeBee 2023

import React, { ReactElement } from 'react';
import { Upload } from 'antd';
import { UploadChangeParam, UploadFile } from 'antd/lib/upload/interface';
import { classList } from '@Helpers/className';
import { ICONS } from '@Constants/iconsApp';

import './UploadSingleFile.scss';

const { Dragger } = Upload;

interface UploadSingleFileProps {
    value?: UploadFile;
    text: string | React.ReactElement;
    onChange?: (data?: UploadFile) => void;
    accept?: string;
    className?: string;
}

const UploadSingleFile = ({ value, text, onChange, accept, className }: UploadSingleFileProps): ReactElement => {
    const handleOnChange = ({ file, fileList }: UploadChangeParam<UploadFile>) => {
        if (fileList.length) {
            onChange?.(file);
        } else {
            onChange?.(undefined);
        }
    };

    return (
        <Dragger
            beforeUpload={(): boolean => false}
            multiple={false}
            listType="picture"
            className={classList({ 'hide-drop-zone': value }, className)}
            onChange={handleOnChange}
            fileList={value ? [value] : []}
            accept={accept}
            iconRender={() => (
                <div className="UploadSingleFile__IconRender">
                    <ICONS.FileImageOutlined />
                </div>
            )}
        >
            <span className="upload-single-file__text">{text}</span>
        </Dragger>
    );
};

export default UploadSingleFile;
